(function(root) {
define("casino/providers/netent/gameinclusion", [], function() {
  return (function() {
(function () {
	var a = {}, b = function (c) {
		var g = c.split("."), e = a, d, f;
		for (d = g[0] === "gi" ? 1 : 0, f = g.length; d < f; d++) {
			e = e[g[d]] = e[g[d]] || {}
		}
		return e
	};
	(function (c) {
		c.dom = {
			postMessage: function (e) {
				var d = Array.prototype.slice.call(arguments, 1);
				e.contentWindow.postMessage.apply(e.contentWindow, d)
			}, on: function (d, e, f) {
				if (d.addEventListener) {
					d.addEventListener(e, f)
				} else {
					d.attachEvent("on" + e, f)
				}
			}, appendToHead: function (d) {
				document.getElementsByTagName("head")[0].appendChild(d)
			}, redirect: function (d) {
				window.location = d
			}
		}
	}(b("gi.utils")));
	(function (c, e) {
		c.GiError = function d(g, f) {
			if (typeof g !== "number") {
				f = g;
				g = 0
			}
			this.code = g;
			this.message = e.errorMessages[g].replace("<error>", f);
			this.error = f
		}
	}(b("gi.utils.error"), b("gi.resources")));
	(function (d, c) {
		d.buildQuery = function (e, g) {
			var k = "";
			var j = "?";
			for (var f = 0; f < g.length; f++) {
				var h = e[g[f].from];
				if (h !== undefined && h.length !== 0) {
					k += j + g[f].to + "=" + encodeURIComponent(h);
					j = "&"
				}
			}
			return k
		}
	}(b("gi.utils.query"), b("gi.resources.constants")));
	(function (e, c) {
		e.combine = (function () {
			var f = function (h, g) {
				var i = JSON.parse(JSON.stringify(h));
				for (var j in g) {
					if (typeof g[j] === "object") {
						h[j] = h[j] || {};
						i[j] = e.combine(h[j], g[j])
					} else {
						i[j] = g[j]
					}
				}
				return i
			};
			return function () {
				var h = arguments[0], g;
				for (var j = 1; j < arguments.length; j++) {
					g = arguments[j];
					h = f(h, g)
				}
				return h
			}
		}());
		var d = function () {
			if (window.XMLHttpRequest) {
				return new XMLHttpRequest()
			} else {
				if (window.ActiveXObject) {
					return new ActiveXObject("Microsoft.XMLHTTP")
				} else {
					return null
				}
			}
		};
		e.getJson = function (g, i, f) {
			var h;
			if (window.XDomainRequest) {
				h = new window.XDomainRequest();
				h.contentType = "text/plain";
				h.onload = function () {
					i(JSON.parse(h.responseText))
				};
				h.onerror = f;
				h.ontimeout = f;
				h.open("GET", g);
				h.send()
			} else {
				h = d();
				h.open("GET", g, true);
				h.onreadystatechange = function () {
					if (h.readyState === 4) {
						if (h.status === 200) {
							i(JSON.parse(h.responseText))
						} else {
							f(h)
						}
					}
				};
				h.send()
			}
		};
		e.resize = function (o, g, i, k, p) {
			var f = /^(\d*)(.*)$/, j = f.exec(i), t = f.exec(k), m = f.exec(o), n = f.exec(g), h = j[2] || "px", s = parseInt(m[1]), r = parseInt(n[1]), w = parseInt(j[1]), u = parseInt(t[1]), v, l, q = {};
			if (p) {
				v = s / r;
				l = r / s;
				if (s === r) {
					if (w > u) {
						q.width = u;
						q.height = u
					} else {
						q.width = w;
						q.height = w
					}
					q.width = w;
					q.height = w * l
				} else {
					if (w * l <= u) {
						q.width = w;
						q.height = w * l
					} else {
						q.height = u;
						q.width = u * v
					}
				}
			} else {
				q.width = w;
				q.height = u
			}
			q.width = Math.round(q.width) + h;
			q.height = Math.round(q.height) + h;
			return q
		};
		e.capitalize = function (f) {
			return f.charAt(0).toUpperCase() + f.substr(1)
		};
		e.callEveryWithArguments = function (f, g) {
			if (f !== undefined) {
				for (var h = 0; h < f.length; h++) {
					f[h].apply(null, g)
				}
			}
		};
		e.flatten = function (l, h) {
			var g = {};
			for (var j in l) {
				if (!l.hasOwnProperty(j)) {
					continue
				}
				if ((typeof l[j]) === "object") {
					var k = e.flatten(l[j], h);
					for (var f in k) {
						if (!k.hasOwnProperty(f)) {
							continue
						}
						g[h ? j + "." + f : f] = k[f]
					}
				} else {
					g[j] = l[j]
				}
			}
			return g
		};
		e.contains = function (g, f) {
			if (g.indexOf) {
				return g.indexOf(f) > -1
			} else {
				if (typeof g === "object") {
					return g.hasOwnProperty(f)
				}
			}
		};
		e.removeMissingProperties = function (g) {
			for (var f in g) {
				if (g[f] === null || g[f] === undefined) {
					delete g[f]
				}
			}
		};
		e.map = function (i, h) {
			for (var g in i) {
				if (i.hasOwnProperty(g)) {
					i[g] = h(i[g])
				}
			}
			return i
		};
		e.encodeAll = function (f) {
			return e.map(f, function (g) {
				return typeof g === "string" ? encodeURIComponent(g) : g
			})
		}
	}(b("gi.utils.tools"), b("gi.utils.error")));
	(function (c) {
		c.isObject = function (d) {
			return typeof d === "object" && d !== null
		};
		c.isVerifiedString = function (d) {
			return /^[a-zA-Z0-9-,._&=]+$/.test(d) && typeof d === "string"
		};
		c.isString = function (d) {
			return typeof d === "string"
		};
		c.isVerifiedUrl = function (d) {
			return /^https?:\/\/([a-zA-Z0-9-_.:~]*(\.cydmodule\.com|\.necorp\.dom|\.casinomodule\.com|\.netentertainment\.com)|localhost:[0-9]*)/.test(d)
		};
		c.isAbsoluteUrl = function (d) {
			return /^[a-zA-Z]+:\/\/.*\..*$/.test(d)
		};
		c.isBoolean = function (d) {
			return typeof d === "boolean"
		};
		c.isCorrectSize = function (f) {
			var e = /^\d*\.?\d+[px|em|%|pt|in|cm|mm|ex|pc|rem|vw|vh]*$/.test(f), d = parseFloat(f) <= 10000;
			return d && e
		};
		c.isLanguage = function (d) {
			return c.isString(d) && d.length === 2
		};
		c.isAnyOf = function (e, d) {
			return e.indexOf(d) >= 0
		};
		c.isFunction = function (d) {
			return typeof d === "function"
		};
		c.isNumber = function (d) {
			return typeof d === "number"
		};
		c.isExistingId = function (d) {
			return document.getElementById(d) !== null
		};
		c.isArray = function (d) {
			return Object.prototype.toString.call(d) === "[object Array]"
		};
		c.isDefined = function (d) {
			return typeof d !== "undefined"
		};
		c.and = function () {
			var d = arguments;
			return function (g) {
				var e = true;
				for (var f = 0; f < d.length; f++) {
					e = e && d[f](g)
				}
				return e
			}
		};
		c.or = function () {
			var d = arguments;
			return function (g) {
				var e = true;
				for (var f = 0; f < d.length; f++) {
					e = e || d[f](g)
				}
				return e
			}
		};
		c.not = function (d) {
			return function (e) {
				return !d(e)
			}
		};
		c.isCallback = c.or(c.not(c.isDefined), c.and(c.isDefined, c.isFunction))
	}(b("gi.utils.validators")));
	(function (c) {
		c.extendTimeout = 30000;
		c.directoryFilePath = "gameinclusion/directory/directory.json";
		c.swfObjectPath = "gameinclusion/library/swfobject.js";
		c.expressInstallPath = "gameinclusion/library/expressInstall.swf";
		c.gameRulesPath = "game/gamerules.jsp";
		c.gameHostPath = "live_casino/";
		c.liveCasinoGameFamily = "livecasino-games"
	}(b("gi.resources.constants")));
	(function (c) {
		c.defaultParameters = {
			flashParams: {
				menu: false,
				base: ".",
				quality: "high",
				scale: "exactfit",
				allowscriptaccess: "always",
				ignoreminimumtime: false,
				provisionSwfObject: true,
				bgcolor: "#000000",
				allowFullScreen: true,
				allowFullScreenInteractive: true
			},
			targetElement: "neGameClient",
			language: "en",
			fullScreen: false,
			enforceRatio: true,
			casinoBrand: "default",
			debugMode: false,
			defaultAudio: true,
			walletMode: "basic",
			mobileParams: {},
			staticSharedUrl: "http://static-shared.casinomodule.com/gameclient_html/devicedetection/current"
		}
	}(b("gi.resources")));
	(function (c) {
		c.errorMessages = {
			0: "Unknown error: <error>",
			1: 'Value for "<error>" is invalid',
			2: 'Launch parameter "<error>" does not exist',
			3: "Launch configuration is not an object",
			4: "Could not retrieve game configuration",
			5: "Could not retrieve game path",
			6: "Presentation type <error> is not supported by Game Inclusion",
			7: "Events are not available in this game",
			8: "Callback function was not provided",
			9: "This functionality is not supported by this game",
			10: "Wrong number of arguments",
			11: "No answer from game",
			12: "Functionality is not available in current game state",
			13: "SWFObject could not launch game",
			14: "Could not load SWFObject",
			15: "Failed to create game url",
			16: "Target element does not exist",
			17: 'No value provided for mandatory parameter "<error>"',
			18: "Unable to launch HTML game",
			20: "Could not retrieve game path directory"
		}
	}(b("gi.resources")));
	(function (d, c) {
		d.parameterValidation = {
			casinoBrand: c.isVerifiedString,
			customParameters: c.isString,
			debugMode: c.isBoolean,
			defaultAudio: c.isBoolean,
			enforceRatio: c.isBoolean,
			fullScreen: c.isBoolean,
			gameId: c.isVerifiedString,
			gameName: c.isVerifiedString,
			gameServer: c.isVerifiedUrl,
			height: c.isCorrectSize,
			helpUrl: c.isAbsoluteUrl,
			lang: c.isLanguage,
			language: c.isLanguage,
			operatorId: c.isVerifiedString,
			sessionId: c.isVerifiedString,
			staticServer: c.isVerifiedUrl,
			targetElement: c.isVerifiedString,
			walletMode: c.isAnyOf.bind(null, ["basic", "seamlesswallet", "mixed"]),
			width: c.isCorrectSize,
			flashParams: c.isObject,
			"flashParams.accountType": c.isAnyOf.bind(null, ["CASINOMODULE_WALLET", "SEAMLESS_WALLET"]),
			"flashParams.allowFullScreen": c.isBoolean,
			"flashParams.allowFullScreenInteractive": c.isBoolean,
			"flashParams.allowscriptaccess": c.isAnyOf.bind(null, ["always", "samedomain", "never"]),
			"flashParams.base": c.isString,
			"flashParams.bgcolor": c.isString,
			"flashParams.brandingLocale": c.isLanguage,
			"flashParams.casinoId": c.isVerifiedString,
			"flashParams.customLeaveTable": c.isBoolean,
			"flashParams.disableSendChat": c.isBoolean,
			"flashParams.gameHostURL": c.isVerifiedUrl,
			"flashParams.ignoreminimumtime": c.isBoolean,
			"flashParams.integrationTest": c.isBoolean,
			"flashParams.lobbyURL": c.isAbsoluteUrl,
			"flashParams.menu": c.isBoolean,
			"flashParams.provisionSwfObject": c.isBoolean,
			"flashParams.quality": c.isAnyOf.bind(null, ["low", "autolow", "medium", "high", "autohigh", "best"]),
			"flashParams.scale": c.isAnyOf.bind(null, ["default", "exactfit", "noborder", "noscale"]),
			"flashParams.showMiniLobby": c.isBoolean,
			"flashParams.tableId": c.isVerifiedString,
			"flashParams.wmode": c.isAnyOf.bind(null, ["opaque", "direct", "window", "transparent", "gpu"]),
			mobileParams: c.isObject,
			"mobileParams.depositAvailable": c.isBoolean,
			"mobileParams.keepAliveInterval": c.isNumber,
			"mobileParams.keepAliveURL": c.isAbsoluteUrl,
			"mobileParams.lobbyUrl": c.isString
		}
	}(b("gi.resources"), b("gi.utils.validators")));
	(function (h, e, g, c, d) {
		var f = function (k, j) {
			for (var i in j) {
				if (j.hasOwnProperty(i)) {
					if (!k[i](j[i])) {
						throw new d.GiError(1, i)
					}
				}
			}
		};
		h.Base = function (k, i, j) {
			var l = this;
			i = i || {};
			l.hide = function () {
				k.style.visibility = "hidden"
			};
			l.show = function () {
				k.style.visibility = "visible"
			};
			l.resize = function (o, m) {
				var n = e.resize(i.width, i.height, o, m, i.enforceRatio);
				k.style.width = n.width;
				k.style.height = n.height
			};
			l.addEventListener = function (m, p, n) {
				try {
					f({eventName: c.isString, callback: c.isFunction, error: c.isCallback}, {eventName: m, callback: p, error: n});
					if (!i.netentExtendSupported) {
						if (c.isFunction(n)) {
							n(new d.GiError(7))
						}
					} else {
						if (j[m] === undefined) {
							j[m] = []
						}
						j[m].push(p)
					}
				} catch (o) {
					if (c.isDefined(n)) {
						if (o instanceof d.GiError) {
							n(o)
						} else {
							n(new d.GiError(o))
						}
					}
				}
			};
			l.removeEventListener = function (m, p) {
				var o = j[m], n;
				if (o !== undefined) {
					n = o.indexOf(p);
					if (n >= 0) {
						o.splice(n, 1)
					}
				}
			};
			if (i.fullScreen) {
				g.on(window, "resize", function () {
					var n = window.innerWidth || document.documentElement.clientWidth, m = window.innerHeight || document.documentElement.clientHeight;
					l.resize(n, m)
				})
			}
		};
		h.Base.prototype.get = function (i, j) {
			f({property: c.isString, success: c.isFunction}, {property: i, success: j})
		};
		h.Base.prototype.set = function (j, i, k) {
			f({property: c.isString, value: c.and(c.isDefined, c.not(c.isFunction)), success: c.isCallback}, {property: j, value: i, success: k})
		};
		h.Base.prototype.call = function (j, i, k) {
			f({action: c.isString, args: c.isArray, success: c.isCallback}, {action: j, args: i, success: k})
		}
	}(b("gi.extend"), b("gi.utils.tools"), b("gi.utils.dom"), b("gi.utils.validators"), b("gi.utils.error")));
	(function (g, e, d, c) {
		g.Flash = function f(k, i) {
			var j = {}, h = {}, l = this;
			g.Base.call(this, k, i, j);
			var m = function (o, p) {
				var q = k[o], n;
				if (typeof q !== "function") {
					throw 9
				}
				n = q.apply(k, p);
				return c.isArray(n) ? n[1] : undefined
			};
			l.get = function (p, r, n) {
				try {
					g.Base.prototype.get.call(this, p, r, n);
					var o = m("get" + e.capitalize(p), []);
					r(o)
				} catch (q) {
					if (c.isDefined(n)) {
						if (q instanceof d.GiError) {
							n(q)
						} else {
							n(new d.GiError(q))
						}
					}
				}
			};
			l.set = function (p, o, r, n) {
				try {
					g.Base.prototype.set.call(this, p, o, r, n);
					m("set" + e.capitalize(p), [o]);
					r()
				} catch (q) {
					if (c.isDefined(n)) {
						if (q instanceof d.GiError) {
							n(q)
						} else {
							n(new d.GiError(q))
						}
					}
				}
			};
			l.call = function (o, q, s, p) {
				try {
					g.Base.prototype.call.call(this, o, q, s, p);
					if (e.contains(h, o)) {
						h[o](o, q, s, p)
					} else {
						var n = m(o, q);
						if (n === "success") {
							s()
						} else {
							if (n === "missingArgument") {
								throw 10
							} else {
								if (n) {
									throw n
								}
							}
						}
					}
				} catch (r) {
					if (c.isDefined(p)) {
						if (r instanceof d.GiError) {
							p(r)
						} else {
							p(new d.GiError(r))
						}
					}
				}
			};
			window.gameEventHandler = function (p) {
				var o = j[p[0]], n = p.slice(1);
				e.callEveryWithArguments(o, n)
			};
			window.error = function (n) {
				window.gameEventHandler(["gameError", 0, n])
			};
			h.reloadBalance = function (n, o, p) {
				m("reloadbalance", []);
				p()
			};
			h.captureScreenshot = function (n, o, p) {
				window.displayFlashScreenshot = function (q) {
					p(q)
				};
				m("captureScreenshot", o)
			}
		}
	}(b("gi.extend"), b("gi.utils.tools"), b("gi.utils.error"), b("gi.utils.validators")));
	(function (i, h, d, f, e, c) {
		i.Html = function g(l, j) {
			var k = 0, u = {}, s = {}, p, t, o, r, n, m, q = function () {
			};
			i.Base.call(this, l, j, s);
			o = function (v) {
				var w = Array.prototype.slice.call(arguments, 1), x = s[v];
				f.callEveryWithArguments(x, w)
			};
			r = function (w) {
				var v = u[w];
				if (v) {
					clearTimeout(v.timeout);
					delete u[w]
				} else {
					v = {success: q, error: q}
				}
				return v
			};
			n = function (x) {
				var w = r(x), y = w.success, v = Array.prototype.slice.call(arguments, 1);
				y.apply(null, v)
			};
			m = function (x, z, v) {
				var w = r(x), y = w.error;
				y(new e.GiError(z, v))
			};
			t = function (w) {
				var x = w.data[0], v = w.data.slice(1);
				if (x === "success") {
					n.apply(null, v)
				} else {
					if (x === "error") {
						m.apply(null, v)
					} else {
						if (x === "event") {
							o.apply(null, v)
						}
					}
				}
			};
			p = function (y, v, x, A, w) {
				try {
					k = k + 1;
					u[k] = {
						success: A || q, error: w || q, timeout: setTimeout((function (B) {
							return function () {
								m(B, 11)
							}
						}(k)), d.extendTimeout)
					};
					h.postMessage(l, [y, k, v].concat(x), "*")
				} catch (z) {
					w(new e.GiError(z))
				}
			};
			this.get = function (w, y, v) {
				try {
					i.Base.prototype.get.call(this, w, y, v);
					p("get", w, [], y, v)
				} catch (x) {
					if (c.isDefined(v)) {
						if (x instanceof e.GiError) {
							v(x)
						} else {
							v(new e.GiError(x))
						}
					}
				}
			};
			this.set = function (x, w, z, v) {
				try {
					i.Base.prototype.set.call(this, x, w, z, v);
					p("set", x, [w], z, v)
				} catch (y) {
					if (c.isDefined(v)) {
						if (y instanceof e.GiError) {
							v(y)
						} else {
							v(new e.GiError(y))
						}
					}
				}
			};
			this.call = function (v, x, z, w) {
				try {
					i.Base.prototype.call.call(this, v, x, z, w);
					p("call", v, x, z, w)
				} catch (y) {
					if (c.isDefined(w)) {
						if (y instanceof e.GiError) {
							w(y)
						} else {
							w(new e.GiError(y))
						}
					}
				}
			};
			h.on(window, "message", t)
		}
	}(b("gi.extend"), b("gi.utils.dom"), b("gi.resources.constants"), b("gi.utils.tools"), b("gi.utils.error"), b("gi.utils.validators")));
	(function (f, e, m, i, h) {
		var g = {}, o, r, c, d, n, q, j, l, k, p;
		o = function (s, v) {
			var t = e.parameterValidation[s];
			if (t) {
				if (!t(v)) {
					throw new h.GiError(1, s)
				}
			}
			try {
				Object.getOwnPropertyNames(v)
			} catch (u) {
				return
			}
		};
		r = function (t) {
			if (i.isObject(t)) {
				if (t.sessionId === undefined) {
					throw new h.GiError(17, "sessionId")
				} else {
					if (t.gameId === undefined && t.gameName === undefined) {
						throw new h.GiError(17, "gameName")
					} else {
						if (t.staticServer === undefined) {
							throw new h.GiError(17, "staticServer")
						} else {
							if (t.gameServer === undefined) {
								throw new h.GiError(17, "gameServer")
							}
						}
					}
				}
				var u = m.flatten(t, true);
				for (var s in u) {
					if (u.hasOwnProperty(s)) {
						o(s, u[s])
					}
				}
			} else {
				throw 3
			}
		};
		q = function (s) {
			s.width = s.defaultWidth;
			s.height = s.defaultHeight;
			s.flashParams = {quality: s.defaultResolution, wmode: s.defaultWmode};
			if (i.isString(s.netentExtendSupported)) {
				s.netentExtendSupported = s.netentExtendSupported === "true"
			}
			delete s.defaultWidth;
			delete s.defaultHeight;
			delete s.defaultResolution;
			delete s.defaultWmode
		};
		d = function (u, w, y, x) {
			var t, s, v;
			w.gameId = u[w.gameName] || w.gameId;
			if (!w.gameId) {
				throw 5
			}
			if (w.gameId.slice(-3) === "_sw") {
				w.walletMode = "seamlesswallet";
				w.gameId = w.gameId.slice(0, -3)
			}
			t = u[w.gameId];
			if (!t) {
				throw 5
			}
			if (w.casinoBrand) {
				t = t.replace("<casinobrand>", w.casinoBrand)
			} else {
				t = t.replace("<casinobrand>/", "")
			}
			t = (t[0] === "/" ? t.slice(1) : t);
			if (!i.isAbsoluteUrl(t)) {
				t = w.staticServer + t
			}
			s = function (z) {
				try {
					if (!i.isObject(z)) {
						throw 4
					}
					z.gamePath = t.replace(w.gameId + ".json", "");
					q(z);
					n(z, w, y, x)
				} catch (A) {
					if (A instanceof h.GiError) {
						x(A)
					} else {
						x(new h.GiError(A))
					}
				}
			};
			v = function (z) {
				if (z instanceof h.GiError) {
					x(z)
				} else {
					x(new h.GiError(4, z))
				}
			};
			m.getJson(t, s, v)
		};
		c = function (s, w, t) {
			var v, x;
			x = function (y) {
				try {
					if (!i.isObject(y)) {
						throw 5
					}
					d(y, s, w, t)
				} catch (z) {
					if (z instanceof h.GiError) {
						t(z)
					}
					t(new h.GiError(z))
				}
			};
			v = s.staticServer + e.constants.directoryFilePath;
			var u = function (y) {
				if (y instanceof h.GiError) {
					t(y)
				} else {
					t(new h.GiError(20, y))
				}
			};
			m.getJson(v, x, u)
		};
		l = function (t, s) {
			if (t.fullScreen) {
				t.width = (window.innerWidth || document.documentElement.clientWidth) + "px";
				t.height = (window.innerHeight || document.documentElement.clientHeight) + "px"
			}
			var u = m.resize(s.width, s.height, t.width, t.height, t.enforceRatio);
			t.width = u.width;
			t.height = u.height
		};
		j = function (s, t) {
			var u = m.combine(e.defaultParameters, s, t);
			if (s.flashParams.wmode === "direct") {
				u.flashParams.wmode = "direct"
			}
			if (u.walletMode === "seamlesswallet") {
				u.gameId = u.gameId + "_sw"
			}
			l(u, s, t);
			return u
		};
		n = function (v, s, z, u) {
			var t, y, x, w;
			t = j(v, s);
			if (v.technologyPresentation !== "redirect") {
				if (!i.isExistingId(t.targetElement)) {
					throw 16
				}
			}
			y = function (A) {
				z(new w.extend(A, t))
			};
			x = g[t.technologyPresentation];
			if (x && (w = x[t.technologyType])) {
				w.launch(t, y, u)
			} else {
				throw new h.GiError(6, t.technologyPresentation + " " + t.technologyType)
			}
		};
		k = function (t) {
			var u = /^.*\.[a-zA-Z]*\/(.*)$/, s = u.exec(t);
			if (s !== null) {
				t = t.replace(s[1], "")
			}
			return t
		};
		p = function (s) {
			var v = ["staticServer", "gameServer"];
			s.staticServer = k(s.staticServer);
			for (var u = 0; u < v.length; u++) {
				var t = s[v[u]];
				if (t[t.length - 1] !== "/") {
					s[v[u]] = t + "/"
				}
			}
		};
		f.launch = function (s, v, t) {
			v = v || function () {
			};
			t = t || function () {
			};
			try {
				r(s);
				p(s);
				c(s, v, t)
			} catch (u) {
				if (u instanceof h.GiError) {
					t(u)
				} else {
					t(new h.GiError(u))
				}
			}
		};
		f.addTechnologyType = function (u, t, v, s) {
			if (g[u] === undefined) {
				g[u] = {}
			}
			g[u][t] = {launch: v, extend: s}
		}
	}(b("gi.launch.launcher"), b("gi.resources"), b("gi.utils.tools"), b("gi.utils.validators"), b("gi.utils.error")));
	(function (i, g, n, f, h) {
		var l, o, k, j, e, c, d = "gi-swfobject", m;
		l = function (q) {
			var p = q.helpUrl, r = "directories=no,location=no,menubar=no,resizable=no,scrollbars=yes,status=no,toolbar=no,width=440,height=420", t = q.gameServer + n.gameRulesPath, s = "?game=" + q.gameId + "&lang=" + q.language, u = "rules";
			p = p || t + s;
			return encodeURIComponent('javascript:(function() { var remote = window.open("' + p + '", "' + u + '", "' + r + '"); }());')
		};
		o = function (p) {
			var q = {
				server: p.gameServer,
				helpURL: l(p),
				closeURL: "javascript:window.close()",
				lang: p.language,
				gameId: p.gameId,
				gameurl: p.legacyGameMainFileName,
				sessid: p.sessionId,
				doDebug: p.debugMode,
				fullscreen: p.fullScreen,
				disableAudio: !p.defaultAudio,
				ignoreminimumtime: p.flashParams.ignoreminimumtime,
				customParameters: encodeURIComponent(p.customParameters)
			};
			if (p.gameFamily === n.liveCasinoGameFamily) {
				m(q, p)
			}
			h.removeMissingProperties(q);
			return q
		};
		m = function (q, p) {
			q.accountType = p.flashParams.accountType;
			q.brandingLocale = p.flashParams.brandingLocale;
			q.casinoId = p.flashParams.casinoId;
			q.customLeaveTable = p.flashParams.customLeaveTable;
			q.disableSendChat = p.flashParams.disableSendChat;
			q.gameHostURL = p.staticServer + n.gameHostPath;
			q.integrationTest = p.flashParams.integrationTest;
			q.jsonRequestURL = p.gameServer;
			q.lobbyURL = p.flashParams.lobbyURL;
			q.tableId = p.flashParams.tableId;
			q.sessionid = p.sessionId;
			q.showMiniLobby = p.flashParams.showMiniLobby;
			q.wmode = p.flashParams.wmode
		};
		k = function (q) {
			var p = {
				menu: q.flashParams.menu,
				base: q.flashParams.base,
				quality: q.flashParams.quality,
				scale: q.flashParams.scale,
				allowscriptaccess: q.flashParams.allowscriptaccess,
				wmode: q.flashParams.wmode,
				//bgcolor: q.flashParams.bgcolor,
				allowFullScreen: q.flashParams.allowFullScreen,
				allowFullScreenInteractive: q.flashParams.allowFullScreenInteractive
			};
			h.removeMissingProperties(p);
			h.encodeAll(p);
			p.bgcolor = q.flashParams.bgcolor;
			return p
		};
		j = function (r, A, v) {
			var w = r.gamePath + r.relativeLoaderUrl.replace("<language>", r.language), u = r.targetElement, p = r.width, B = r.height, q = r.technologyVersion, x = r.staticServer + n.expressInstallPath, t = o(r), z = k(r), s = {}, y = function (C) {
				if (C.success) {
					A()
				} else {
					v(new f.GiError(13))
				}
			};
			window.swfobject.embedSWF(w, u, p, B, q, x, t, z, s, y)
		};
		e = function (r, s, q) {
			var p = document.createElement("script");
			p.setAttribute("src", r.staticServer + n.swfObjectPath);
			p.setAttribute("id", d);
			p.onload = function () {
				j(r, s, q)
			};
			p.onerror = function () {
				q(new f.GiError(14))
			};
			g.appendToHead(p)
		};
		c = function () {
			return document.getElementById(d) !== null
		};
		i.launch = function (q, t, p) {
			try {
				var s = function () {
					var u = document.getElementById(q.targetElement);
					t(u)
				};
				if (q.flashParams.provisionSwfObject && !c()) {
					e(q, s, p)
				} else {
					j(q, s, p)
				}
			} catch (r) {
				p(new f.GiError(r))
			}
		}
	}(b("gi.launch.methods.embed.flash"), b("gi.utils.dom"), b("gi.resources.constants"), b("gi.utils.error"), b("gi.utils.tools")));
	(function (g, i, d, h) {
		var e = [{to: "server", from: "gameServer"}, {to: "lang", from: "language"}, {to: "sessId", from: "sessionId"}, {
			to: "gameId",
			from: "gameId"
		}, {to: "operatorId", from: "casinoBrand"}, {to: "historyURL", from: "historyUrl"}, {
			to: "staticsharedurl",
			from: "staticSharedUrl"
		}, {to: "customParameters", from: "customParameters"}];
		var j = function (l) {
			var k = l.gamePath + l.relativeLoaderUrl + i.buildQuery(l, e);
			if (!d.isAbsoluteUrl(k)) {
				throw 15
			}
			return k
		};
		var f = function (q, p, n, k, o, l) {
			var m = document.createElement("iframe");
			m.setAttribute("id", q);
			m.setAttribute("src", p);
			m.setAttribute("frameBorder", "0");
			m.style.width = typeof n === "number" ? n + "px" : n;
			m.style.height = typeof k === "number" ? k + "px" : k;
			m.onload = function () {
				o(m)
			};
			m.onerror = function () {
				l(new h.GiError(18))
			};
			return m
		};
		var c = function (m, l) {
			var k = document.getElementById(m);
			k.parentNode.replaceChild(l, k);
			return l
		};
		g.launch = function (l, p, k) {
			try {
				var o = j(l), m = f(l.targetElement, o, l.width, l.height, p, k);
				c(l.targetElement, m)
			} catch (n) {
				k(new h.GiError(n))
			}
		}
	}(b("gi.launch.methods.embed.html"), b("gi.utils.query"), b("gi.utils.validators"), b("gi.utils.error")));
	(function (e, g, c, i, h, f) {
		var d = [{to: "server", from: "gameServer"}, {to: "lang", from: "language"}, {to: "sessId", from: "sessionId"}, {
			to: "gameId",
			from: "gameId"
		}, {to: "operatorId", from: "casinoBrand"}, {to: "lobbyURL", from: "lobbyUrl"}, {to: "disableAudio", from: "disableAudio"}, {
			to: "keepAliveURL",
			from: "keepAliveURL"
		}, {to: "keepAliveInterval", from: "keepAliveInterval"}, {to: "depositAvailable", from: "depositAvailable"}, {
			to: "customParameters",
			from: "customParameters"
		}];
		var j = function (l) {
			var k = l.gamePath + l.relativeLoaderUrl + g.buildQuery(h.flatten(l), d);
			if (!c.isAbsoluteUrl(k)) {
				throw 15
			}
			return k
		};
		e.launch = function (l, n, k) {
			try {
				i.redirect(j(l))
			} catch (m) {
				k(new f.GiError(m))
			}
		}
	}(b("gi.launch.methods.redirect.html"), b("gi.utils.query"), b("gi.utils.validators"), b("gi.utils.dom"), b("gi.utils.tools"), b("gi.utils.error")));
	(function (e, c, d) {
		e.addTechnologyType("embed", "html", c.embed.html.launch, d.Html);
		e.addTechnologyType("embed", "flash", c.embed.flash.launch, d.Flash);
		e.addTechnologyType("redirect", "html", c.redirect.html.launch);
		window.netent = {launch: e.launch}
	}(b("gi.launch.launcher"), b("gi.launch.methods"), b("gi.extend")))
}());
return root.netent = netent;
  }).apply(root, arguments);
});
}(this));

